export const HERO_IMAGE_URL = {
  MOBILE:
    '//images.babylist.com/image/upload/f_auto,q_auto/v1666813723/DME/NY-Cribs-Pump-46.jpg',
  DESKTOP:
    '//images.babylist.com/image/upload/f_auto,q_auto,h_1000/v1670540015/DME/img_hero_dme_high-res.png',
  WIDE: '//images.babylist.com/image/upload/f_auto,q_auto,h_1000/v1670540015/DME/img_hero_dme_high-res.png',
}
export const HERO_MASK =
  '//images.babylist.com/image/upload/v1664225578/hero-mask_kszb5j.svg'
export const THREE_STEPS_PARACHUTE_URL_IMG_URL =
  '//images.babylist.com/image/upload/v1682516479/DME/Package.svg'
export const THREE_STEPS_PORTRAIT_URL_IMG_URL =
  '//images.babylist.com/image/upload/v1682516479/DME/Paperwork.svg'
export const THREE_STEPS_PUMP_IMG_URL =
  '//images.babylist.com/image/upload/v1682516479/DME/Pump.svg'
export const PRESCRIPTION_FORM =
  '//images.babylist.com/image/upload/v1661549096/DME/Breast-Pump-Prescription-Request-Form.pdf'
